// import Swiper from "swiper/bundle";
import Swiper, { Navigation, Pagination } from "swiper";
import inView from "in-view";
Swiper.use([Navigation, Pagination]);

export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
			swiperArgs: {
				slidesPerView: "auto",
				grabCursor: true,
				loop: false,
				loopedSlides: 3,
				minSlides: 2,
				autoadvance: false,
				autoopts: {
					maxcycle: 1500,
					currcycle: 0,
				},
				// gutter 32px
				spaceBetween: 60,
				// speed: 470,
				// allowTouchMove: false,
				// watchSlidesProgress: false,
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
			},
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "SwiperSlideshow";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			let appScope = this;
			let args = this.options.swiperArgs;

			if (this.$el.classList.contains("carousel-html")) {
				args.minSlides = 1;
				args.slidePerView = 1;
				args.loopedSlides = 0;
				args.loop = true;
				// touch minimun distance to trigger slide
				args.threshold = 20;
				// prevent vertical scroll when moving swiper
				args.touchAngle = 45;
				// add dot pagination
				args.pagination = {
					el: this.$el.parentElement.querySelector(
						".swiper-pagination"
					),
					clickable: true,
				};
				// args.autoadvance = true;
			}
			if (this.$el.classList.contains("carousel-img")) {
				args.minSlides = 1;
				args.slidePerView = 1;
				args.loopedSlides = 0;
				args.spaceBetween = 0;
				args.loop = true;
				// add left right pagination
				args.navigation = {
					nextEl: this.$el.parentElement.querySelector(
						".swiper-button-next"
					),
				};
				args.pagination = {
					el: this.$el.parentElement.querySelector(
						".swiper-pagination"
					),
					clickable: true,
				};
				// args.autoadvance = true;
			}
			if (this.$el.classList.contains("carousel-large")) {
				args.minSlides = 2;
				args.loopedSlides = 0;
				args.loop = false;
			}

			if (
				this.$el.querySelectorAll(".swiper-slide").length <
				args.minSlides
			) {
				this.$el.classList.add("no-swiper");
				return;
			}

			args.navigation = {
				nextEl: this.$el.parentElement.querySelector(
					".swiper-button-next"
				),
				prevEl: this.$el.parentElement.querySelector(
					".swiper-button-prev"
				),
			};
			if (this.$el.classList.contains("carousel-sm")) {
				args.loop = true;
			}
			if (this.$el.classList.contains("centered")) {
				args.loop = true;
				args.breakpoints = {
					768: {
						centeredSlides: true,
					},
				};
			}
			// if element has data attribute
			if (this.$el.classList.contains("auto-advance")) {
				args.autoadvance = true;

				// bind click event on swiper-button-prev and swiper-button-next to stop autoadvance
				let buttons = this.$el.parentElement.querySelectorAll(
					".swiper-button-prev, .swiper-button-next"
				);
				for (let i = 0; i < buttons.length; i++) {
					buttons[i].addEventListener("click", (e) => {
						e.preventDefault();
						// this.swiper.autoplay.stop();
						args.autoadvance = false;
						// console.log("stoppped");
						if (this.$el.parentElement.querySelector(".autofuse")) {
							this.$el.parentElement
								.querySelector(".autofuse")
								.remove();
						}
					});
				}
			}
			this.swiper = new Swiper(this.$el, args);

			let paginationEdges =
				this.$el.parentElement.querySelectorAll(".pagination-edge");
			if (paginationEdges.length > 0) {
				for (let i = 0; i < paginationEdges.length; i++) {
					paginationEdges[i].addEventListener("click", (e) => {
						e.preventDefault();
						let target = e.target;
						let direction = target.getAttribute("data-direction");
						if (direction === "prev") {
							this.swiper.slidePrev();
						} else if (direction === "next") {
							this.swiper.slideNext();
						}
					});
				}
			}

			if (this.$el.classList.contains("carousel-img")) {
				// this.swiper.on("init", () => {
				let figcaption = this.$el.querySelector(
					".swiper-slide-active figcaption"
				);
				if (figcaption) {
					appScope.$el.parentElement.parentElement.querySelector(
						".carousel-caption"
					).innerHTML = figcaption.innerHTML;
				} else {
					appScope.$el.parentElement.parentElement.querySelector(
						".carousel-caption"
					).innerHTML = "";
				}
				// });
				this.swiper.on("slideChangeTransitionEnd", () => {
					let figcaption = this.$el.querySelector(
						".swiper-slide-active figcaption"
					);
					if (figcaption) {
						appScope.$el.parentElement.parentElement.querySelector(
							".carousel-caption"
						).innerHTML = figcaption.innerHTML;
					} else {
						appScope.$el.parentElement.parentElement.querySelector(
							".carousel-caption"
						).innerHTML = "";
					}
				});
				// this.swiper.on("slideChangeTransitionEnd", () => {
			}

			if (args.autoadvance && window.innerWidth >= 1024) {
				// if this.$el is inView
				// inView(this.$el)
				// inView.test((this.$el, options) => {

				// });
				this.timerTick();
			} else {
				// console.log("not auto advancing");
			}
		} else {
			this.swiper.destroy(true, true);
		}
	}
	timerTick() {
		let scopeThis = this;
		let args = scopeThis.options.swiperArgs;
		if (!args.autoadvance) {
			return;
		}
		if (inView.is(this.$el)) {
			args.autoopts.currcycle++;
		}
		// console.log(args.autoopts.currcycle);
		if (args.autoopts.currcycle >= args.autoopts.maxcycle) {
			scopeThis.swiper.slideNext();
			args.autoopts.currcycle = 0;
		}

		if (scopeThis.$el.parentElement.querySelector(".autofuse")) {
			scopeThis.$el.parentElement
				.querySelector(".autofuse")
				.setAttribute(
					"style",
					"--autoprogress:" +
						args.autoopts.currcycle / args.autoopts.maxcycle
				);
		}

		// requestAnimationFrame(scopeThis.timerTick);
		setTimeout(function () {
			scopeThis.timerTick();
		}, 1);
	}
}
